import { ApolloQueryResult, gql } from '@apollo/client'

import { client } from '../client'
import { Transportation } from '../../types/transportation';


const FIND_TRANSPORTATION_QUERY = gql`
query FindTransportation($qtirLanguageId: Int!, $findBy: String!, $value: String!) {
  findTransportation(qtirLanguageId: $qtirLanguageId, findBy: $findBy, value: $value) {
    transportation {
      blacklist
      id
      carCompany
      carCompanyId
      carQuantity
      customs
      destination
      destinationId
      driverName
      driverPhoneNumber
      registrationNumber
      schedule
      shipmentNo
      transportationType
      transportationTypeId
      state
      platform
      queueOrder
    }
  }
}
`

interface FindTransportationVars {
  findBy: string,
  value: string,
  qtirLanguageId: number,
}

interface FindTransportationData {
  findTransportation: {
    transportation: Transportation
  }
}


export const findTransportation = async (args: FindTransportationVars): Promise<ApolloQueryResult<FindTransportationData>> => {
  return await client.query<FindTransportationData, FindTransportationVars>({ query: FIND_TRANSPORTATION_QUERY, variables: args })
}
